import { Trans } from "@lingui/macro";
import React, { useEffect } from "react";
import { InputText } from "components/UI/InputText/InputText";
import { useInputChange } from "hooks/useInputChange";
import { Button } from "components/UI/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import { IdOrdersState } from "model/dashboardOrders/dOrdersReducer";
import {
  dOrdersSetDetailProductAC,
  dOrdersSetPriceForProductInCartItemAC,
} from "model/dashboardOrders/dOrdersActionCreators";

// Type
export type typePopupChangePrice = {
  setOpenPopup: React.Dispatch<React.SetStateAction<boolean>>;
};

// Component
export const PopupChangePrice: React.FC<typePopupChangePrice> = ({
  setOpenPopup,
}) => {
  const dispatch = useDispatch();
  const id = useSelector(
    (state: { dOrders: IdOrdersState }) => state.dOrders.detailProduct,
  );
  const {
    value: newPriceValue,
    setValue: setNewPriceValue,
    changeValueHandler: newPriceValueHandler,
  } = useInputChange("");

  useEffect(() => {
    if (newPriceValue.trim().length > 2) {
      setNewPriceValue(newPriceValue.trim().match(/\d{0,12}.\d{0,2}/)![0]);
    }
    // eslint-disable-next-line
  }, [newPriceValue]);

  const onApplyClickHandler = () => {
    if (id && typeof id === "string")
      dispatch(dOrdersSetPriceForProductInCartItemAC(id, newPriceValue));
    setOpenPopup(false);
  };
  //did unmount
  useEffect(() => {
    return () => {
      dispatch(dOrdersSetDetailProductAC(undefined));
    };
  }, [dispatch]);

  return (
    <div className="flex flex-col gap-2 sm:gap-4">
      <div>
        <InputText
          id="changePrice"
          label={<Trans>New price</Trans>}
          type="number"
          value={newPriceValue}
          onChange={newPriceValueHandler}
          minValue={0}
        />
      </div>
      <Button
        type="button"
        onClick={() => onApplyClickHandler()}
        label={<Trans>Apply</Trans>}
      />
    </div>
  );
};
